import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants/app-routes.const';

@Component({
  selector: 'app-layout-error',
  standalone: true,
  imports: [],
  templateUrl: './layout-error.component.html',
  styleUrl: './layout-error.component.scss',
})
export class LayoutErrorComponent implements OnInit, OnDestroy {
  private router = inject(Router);

  timer = 5;
  intervalId: any;
  private redirectId?: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    this.startTimer();
    this.redirectId = setTimeout(() => this.goToHome(), 5000);
  }

  startTimer(): void {
    this.intervalId = setInterval(() => {
      if (this.timer > 0) this.timer--;
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    // Sin esto, si el usuario ya salió («Volver al inicio»), la redirección
    // pendiente lo volvía a mover desde la pantalla en la que estuviera.
    clearTimeout(this.redirectId);
  }

  // Como lrp_frontend: al inicio y no a `/login`, cuyo `ngOnInit` cierra la
  // sesión. Sin sesión, el `RoleGuard` del dashboard ya manda al login.
  goToHome(): void {
    this.router.navigate([APP_ROUTES.DASHBOARD]);
  }
}
